export function checkIsMaintenance(userQueues: ApiQueue[]) {
  for (let i = 0; i < userQueues.length; ++i) {
    const entry = userQueues[i];
    if (entry.name === "Maintenance") {
      return true;
    }
  }
  return false;
}

// Backward compatibility alias
export const checkIsEngineer = checkIsMaintenance;
